import React, { useEffect, useState } from "react";
import { Form, Card, Button, InputNumber, Popconfirm, Space } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import useMessage from "antd/es/message/useMessage";

import { UserService } from "../../../Services/Manage/UserService";
import { ExpenseServices } from "../../../Services/Manage/ExpenseServices";
import GeneralExpenseAdd from "../Expenses/GeneralExpenseAdd";

const CreatePO = ({ onClose, getAllExpense, editPO }) => {
  const [dataSource, setDataSource] = useState([]);
  const [count, setCount] = useState(1);
  const [vendorId, setVendorId] = useState(null);
  const [poId, setPoId] = useState("");
  const [taxId, setTaxId] = useState("");
  const [taxType, setTaxType] = useState("");
  const [message, msgContx] = useMessage();

  const isEdit = !!editPO;

  useEffect(() => {
    if (isEdit) {
    //   console.log("+++", editPO);

      setPoId(editPO.po_id);
      setVendorId(editPO.vendor_id);
      setTaxId(editPO.data[0]?.tax_id);
      setTaxType(editPO.data[0]?.tax_type);

      // Map PO items to table rows
      const mapped = editPO.data.map((item, index) => ({
        ...item,
        key: index + 1,
      }));

      setDataSource(mapped);
    }
  }, [editPO]);
  const generateKey = () => `${Date.now()}-${Math.random()}`;

  const handleNewAdd = () => {
    setDataSource([
      ...dataSource,
      {
        key: generateKey(),
        description: "",
        qty: 1,
        unitprice: 0,
        totalprice: 0,
      },
    ]);
    setCount(count + 1);
  };

  const handleAdd = (identifier) => {
    const newRow = {
      key: generateKey(),
      description: "",
      qty: 1,
      unitprice: 0,
      totalprice: 0,
    };
    const index = dataSource.findIndex(
      (item) => item.id === identifier || item.key === identifier,
    );

    let newData = [...dataSource];
    newData.splice(index + 1, 0, newRow);

    setDataSource(newData);
    setCount(count + 1);
  };

  const handleDelete = async (record) => {
    const newData = dataSource.filter((item) => item.key !== record.key);
    setDataSource(newData);

    const request = await ExpenseServices.deleteExpense(record.id);
    if (request.status) {
      message.success(request.message);
      getAllExpense();
    } else {
      message.warning(request.message);
    }
  };

  const handleChange = (identifier, field, value) => {
    // Handle tax fields separately (header-level tax)
    if (field === "tax_id") {
      setTaxId(value);
      return;
    }

    if (field === "tax_type") {
      setTaxType(value);
      return;
    }

    const newData = dataSource.map((item) => {
      if (item.key === identifier || item.id === identifier) {
        const updatedItem = { ...item, [field]: value };

        const qty = Number(updatedItem.qty) || 0;
        const unitprice = Number(updatedItem.unitprice) || 0;
        const taxPercent = Number(updatedItem.tax_amount) || 0;

        const baseTotal = qty * unitprice;
        const taxValue = baseTotal * (taxPercent / 100);

        updatedItem.totalprice = +(baseTotal + taxValue).toFixed(2);

        return updatedItem;
      }
      return item;
    });

    setDataSource(newData);
  };

  // const handleGeneralSave = async () => {
  //     try {
  //         const user = await UserService.getOmeUser();

  //         const formattedData = dataSource.map(({ key, ...rest }) => ({
  //             ...rest,
  //             added_by: user.uid,
  //             type: "other",
  //             vendor_id: vendorId,
  //             po_id: poId,
  //             tax_id: taxId,
  //             tax_type: taxType,
  //         }));

  //         const request = await ExpenseServices.createExpense(formattedData);

  //         if (request.status) {
  //             message.success(request.message);
  //             handleClose();
  //             getAllExpense();
  //         } else {
  //             message.error(request.message);
  //         }
  //     } catch (error) {
  //         console.error(error);
  //         message.error("Something went wrong");
  //     }
  // };

  const handleGeneralSave = async () => {
    try {
      const user = await UserService.getOmeUser();

      const formattedData = dataSource.map(({ key, ...rest }) => ({
        ...rest,
        added_by: user.uid,
        vendor_id: vendorId,
        po_id: poId,
        tax_id: taxId,
        tax_type: taxType,
        type: "other",
      }));
      const formattedEditData = dataSource.map(
        ({ key, payments, added_on, ...rest }) => ({
          ...rest,
          added_by: user.uid,
          vendor_id: vendorId,
          po_id: poId,
          tax_id: taxId,
          tax_type: taxType,
          type: "other",
        }),
      );

      console.log("formattedData++", formattedEditData);

      const request = editPO
        ? await ExpenseServices.updateExpenseBluk(formattedEditData)
        : await ExpenseServices.createExpense(formattedData);

      if (request.status) {
        message.success(request.message);
        handleClose();
        getAllExpense();
      }
    } catch (err) {
      message.error("Something went wrong");
    }
  };

  const handleClose = () => {
    onClose();
    setDataSource([]);
    setTaxId("");
    setTaxType("");
  };

  return (
    <div>
      {msgContx}

      <Card>
        <Form layout="vertical">
          <GeneralExpenseAdd
            dataSource={dataSource}
            setDataSource={setDataSource}
            handleNewAdd={handleNewAdd}
            handleAdd={handleAdd}
            handleDelete={handleDelete}
            handleChange={handleChange}
            setVendorId={setVendorId}
            vendorId={vendorId}
            setPoId={setPoId}
            setTaxId={setTaxId}
            setTaxType={setTaxType}
            editPO={editPO}
            taxId={taxId}
            taxType={taxType}
          />

          <div
            style={{
              marginTop: 50,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Space>
              <Button size="large" type="primary" onClick={handleGeneralSave}>
                Save
              </Button>
              <Button size="large" onClick={handleClose}>
                Cancel
              </Button>
            </Space>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default CreatePO;
